export const CATEGORY_GROUPS = [
  {
    id: "temel",
    name: "Temel Dersler",
    description: "Tarih, coğrafya ve vatandaşlık dersleri.",
  },
  {
    id: "hukuk",
    name: "Hukuk Dersleri",
    description: "Anayasa, medeni, ceza, borçlar, MÖHUK, İYUK, icra iflas, ticaret, iş, idare, medeni usul ve CMK.",
  },
  {
    id: "egitim",
    name: "Eğitim Bilimleri",
    description: "Öğrenme, gelişim, PDR, öğretim, ölçme ve program geliştirme dersleri.",
  },
];

export const CATEGORY_GROUP_BY_ID = Object.fromEntries(
  CATEGORY_GROUPS.map((group) => [group.id, group])
);

const includesAny = (value, words) => words.some((word) => value.includes(word));

export const inferCategoryGroup = (name = "") => {
  const normalized = name.toLocaleLowerCase("tr-TR");

  if (includesAny(normalized, ["tarih", "coğrafya", "cografya", "vatandaşlık", "vatandaslik"])) {
    return "temel";
  }

  if (
    includesAny(normalized, [
      "anayasa",
      "medeni",
      "ceza",
      "borç",
      "borc",
      "möhuk",
      "mohuk",
      "iyuk",
      "iyük",
      "icra",
      "iflas",
      "ticaret",
      "iş",
      "is hukuku",
      "idare",
      "usul",
      "cmk",
    ])
  ) {
    return "hukuk";
  }

  return "egitim";
};

export const getCategoryGroup = (category) => {
  const groupId = category?.group_id || category?.group || inferCategoryGroup(category?.name);
  return CATEGORY_GROUP_BY_ID[groupId] ? groupId : "egitim";
};
